import { createAsyncThunk } from "@reduxjs/toolkit";
import workshopService from "../../../api/services/workshops";

// Admin Workshop Management
export const getAllWorkshopsForAdmin = createAsyncThunk(
  "workshops/get-all-workshops-for-admin",
  async (params = {}) => {
    return await workshopService.getAllWorkshopsForAdmin(params);
  }
);

export const getWorkshopById = createAsyncThunk(
  "workshops/get-workshop-by-id",
  async (id) => {
    return await workshopService.getWorkshopById(id);
  }
);

export const createWorkshop = createAsyncThunk(
  "workshops/create-workshop",
  async (workshopData) => {
    return await workshopService.createWorkshop(workshopData);
  }
);

export const updateWorkshop = createAsyncThunk(
  "workshops/update-workshop",
  async ({ id, workshopData }) => {
    return await workshopService.updateWorkshop(id, workshopData);
  }
);

export const deleteWorkshop = createAsyncThunk(
  "workshops/delete-workshop",
  async (id) => {
    return await workshopService.deleteWorkshop(id);
  }
);

export const getWorkshopRegistrations = createAsyncThunk(
  "workshops/get-workshop-registrations",
  async (id) => {
    return await workshopService.getWorkshopRegistrations(id);
  }
);

export const updateRegistrationStatus = createAsyncThunk(
  "workshops/update-registration-status",
  async ({ workshopId, registrationId, statusData }) => {
    return await workshopService.updateRegistrationStatus(
      workshopId,
      registrationId,
      statusData
    );
  }
);

export const getWorkshopsStatistics = createAsyncThunk(
  "workshops/get-workshops-statistics",
  async () => {
    return await workshopService.getWorkshopsStatistics();
  }
);

// Public Workshop Access
export const getPublicWorkshops = createAsyncThunk(
  "workshops/get-public-workshops",
  async (params = {}) => {
    return await workshopService.getPublicWorkshops(params);
  }
);

export const getPublicWorkshopById = createAsyncThunk(
  "workshops/get-public-workshop-by-id",
  async (id) => {
    return await workshopService.getPublicWorkshopById(id);
  }
);

export const registerForWorkshop = createAsyncThunk(
  "workshops/register-for-workshop",
  async ({ id, registrationData }) => {
    return await workshopService.registerForWorkshop(id, registrationData);
  }
);

export const getUserWorkshopRegistrations = createAsyncThunk(
  "workshops/get-user-workshop-registrations",
  async (params = {}) => {
    return await workshopService.getUserWorkshopRegistrations(params);
  }
);

export const getWorkshopSchedulesBySKU = createAsyncThunk(
  "workshops/get-workshop-schedules-by-sku",
  async (sku) => {
    return await workshopService.getWorkshopSchedulesBySKU(sku);
  }
);
